import React, { Fragment } from 'react'
import {t} from 'i18next'
import { useNavigate } from 'react-router-dom'
import { Container, Button, Row, Col } from 'reactstrap'

import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb'
import AddUpdateProject from '../../components/projects/AddUpdateProject'


const Projects = () => {
    const Navigate = useNavigate();

    return (
        <Fragment>
            <Breadcrumbs parent={t('breadcrumb.projects')} title={t('breadcrumb.projects')} />
            <Container fluid={true}>
                <Row>
                    <Col md="12">
                        <AddUpdateProject />
                    </Col>
                </Row>
                <div className='d-flex flex-wrap justify-content-between mb-4'>
                    <Button color="danger" className="mt-2 me-2" onClick={() => Navigate(-1)}>{t('back')}</Button>
                </div>
            </Container>
        </Fragment>
    )
}

export default Projects